import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { IS_TEST } from "./config"
const firebaseConfig = {
  production: {
    apiKey: "AIzaSyCDTN4L93UlCa3ff6Iik7eAp8ZakPA0W8E",
    authDomain: "fms-production-4c7f1.firebaseapp.com",
    projectId: "fms-production-4c7f1",
    storageBucket: "fms-production-4c7f1.appspot.com",
    messagingSenderId: "91441011078",
    appId: "1:91441011078:web:ccd3c795bc73d9fac97407",
    measurementId: "G-TC5W48L0LT",
  },
  testing: {
    apiKey: "AIzaSyCmtcEP1zB8WJdOmViAQP_aYL8YbJQFOdo",
    authDomain: "fms-testing.firebaseapp.com",
    projectId: "fms-testing",
    storageBucket: "fms-testing.appspot.com",
    messagingSenderId: "516680909451",
    appId: "1:516680909451:web:1ebfa86c21088ad5774a8e",
    measurementId: "G-DCV3MVMJDC",
  },
}

export const firebase = initializeApp(firebaseConfig[IS_TEST ? "testing" : "production"])
getAnalytics(firebase)
